var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.076,
    height: 22.022,
    viewBox: "0 0 22.076 22.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2.366,
    y1: -0.388,
    x2: 5.285,
    y2: 2.39,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b998e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#27a486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#46b07c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#5db975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#6abe71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fc070"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M495.165,86.512h4.578v14.71h-4.578Zm2.294-7.312a2.654,2.654,0,1,0,2.648,2.648A2.656,2.656,0,0,0,497.459,79.2ZM511.4,86.148a4.807,4.807,0,0,0-4.332,2.38H507V86.512h-4.385v14.71h4.567v-7.28c0-1.919.365-3.774,2.745-3.774,2.348,0,2.38,2.2,2.38,3.9v7.151h4.567V93.149C516.876,89.193,516.029,86.148,511.4,86.148Z",
    transform: "translate(-494.8 -79.2)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinGreen);
export default __webpack_public_path__ + "static/media/linkedinGreen.9a0c6613ebc79547e1d4b051d2ee47d8.svg";
export { ForwardRef as ReactComponent };